module.exports = __webpack_public_path__ + "static/media/babysignal.688d8202.jpg";